<script>
export default {
    name: 'BaseTimePickerMinutes',
};
</script>

<script setup>
import { computed } from 'vue';
import { TYPE } from '@/components/base-components/components/time-picker/index.js';
import BaseTimePickerPicker from '@/components/base-components/components/time-picker/components/picker.vue';
import { getMinutes } from '@/components/base-components/components/time-picker/utils/helpers.js';

const props = defineProps({
    value: {
        type: Date,
    },
    step:  {
        type:      Number,
        default:   1,
        validator: value => value > 0 && value <= 60,
    },
    type:  {
        type:      String,
        default:   TYPE.DEFAULT,
        validator: value => Object.values(TYPE).includes(value),
    },
});

const emit = defineEmits({
    input: null,
});

const model = computed({
    get: () => (props.value ?? new Date()).getMinutes(),
    set: (value) => {
        const date = new Date(props.value ?? new Date());

        date.setMinutes(value);

        emit('input', date);
    },
});
</script>

<template>
    <base-time-picker-picker
        v-model="model"
        :items="getMinutes(step)"
        :type="type"
    />
</template>
